;(async () => {
  const { Core } = await importModule('Core')
  const { $show, $hide } = await importModule('Utils')

  customElements.define(
    'product-sticky-add-to-cart',
    class extends Core {
      elements = {
        bar: '[data-sticky-bar]',
      }

      render() {
        let observer
        const self = this

        let productDetailsElement = document.querySelector('.\\@product')
        if (!productDetailsElement) {
          return
        }

        observer = new IntersectionObserver((entries) => {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              $hide(self.$bar)
            } else {
              if (entry.boundingClientRect.top > window.innerHeight) {
                return
              }
              $show(self.$bar)
            }
          })
        })

        observer.observe(productDetailsElement)
      }
    }
  )
})()
